import Component from "../component";
import { getConfig } from "configuration/config";
import { getLocale, getLocaleLang } from '../../helpers/locale';


export interface IKioskComponent {
    query?: string;
    showDescription?: boolean;
}
export enum KioskComponentEvents {
    LOGO_CLICKED = "logo_clicked",
    LOGOS_LOADED = "logos_loaded",
    LANGUAGE_CHANGED = "language_changed",
    MAP_RELOAD = "map_reload",
}
export default class KioskComponent extends Component<IKioskComponent> {
    public allSponsors: any[] = [];
    public marqueeRows: any[] = [[], [], [], []];
    public defaultTheme!: any;
    public selectedBuilding!: any;
    public sessionDuration!: number;
    public countdownInterval!: number;
    public TIMEOUT_LIMIT: number = 60;
    public isMapReloaded: boolean = false;
    init() {
        this.sessionDuration = 60;
        this.updateSessionCountdown = this.updateSessionCountdown.bind(this);
        this.getSponsoredLogos()
            .then((response: woosmap.map.GeoJSONFeatureCollection) => {
                const sponsorsData = response.features;
                this.shuffleSponsorsArray(sponsorsData);
                this.marqueeRows = [[], [], [], []];
                sponsorsData.forEach((img, index) => {
                    this.marqueeRows[index % 4].push(img);
                });
                this.renderSponsors();
            })
        const $languageSelector = document.getElementById("languageSelector");
        if ($languageSelector) {
            $languageSelector.innerHTML = getLocale().messages.selectLanguage;
        }
        const $rightContainer = document.querySelector('.right-buttons');
        if($rightContainer) {
            const $linkReset = document.createElement('a');
            $linkReset.id = "lnkReset";
            $linkReset.href = "#";
            $linkReset.innerText = getLocale().messages.resetMap;
            $linkReset.style.visibility = 'hidden';
            $linkReset.style.color = '#e30613';
            $linkReset.addEventListener("click", (event) => {
                event.preventDefault();
                this.resetMap();
            })
            $rightContainer.appendChild($linkReset);
        }
        this.initializeLanguageSelector();
    }
    render(): void {

    }
    renderSponsors() {
        this.removeExistingMarquees();

        for (let i = 0; i < 4; i++) {
            this.createMarquee(i);
        }
        requestAnimationFrame(() => {
            this.restartMarqueeAnimation(".marquee");
        });
    }
    createMarquee(rowIndex: number) {
        const marquee = document.querySelector(`#marquee-container-${rowIndex + 1} .marquee`);
        const marqueeContent = document.createElement('div');
        marqueeContent.classList.add('marquee-content');

        if (marquee) {
            this.marqueeRows[rowIndex].forEach((sponsor: any) => {
                const img = document.createElement('img');
                img.src = sponsor.properties.Sponsored_URL;
                img.onerror = () => {
                    console.error(`Failed to load image: ${sponsor.properties.name}`);
                    img.style.display = 'none'; // Hide the broken image
                };
                img.dataset.ref = sponsor.properties.ref;
                marqueeContent.appendChild(img);
            });
            marquee.addEventListener('click', (e) => {
                const target = e.target as HTMLElement;
                if (target.tagName === 'IMG' && target.dataset.ref) {
                    this.startSessionCountdown();
                    this.emit(KioskComponentEvents.LOGO_CLICKED, target.dataset.ref);
                }
            });
            const marqueeClone = marqueeContent.cloneNode(true);
            marquee.appendChild(marqueeContent);
            marquee.appendChild(marqueeClone);
        }
    }
    shuffleSponsorsArray(array: any[]) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
    getSponsoredLogos(): Promise<woosmap.map.GeoJSONFeatureCollection> {
        return new Promise<woosmap.map.GeoJSONFeatureCollection>((resolve, reject) => {
            const indoorService = new woosmap.map.IndoorService();
            const cbSponsoredLogos = (response: woosmap.map.GeoJSONFeatureCollection) => {
                if (response && response.features && response.features.length > 0) {
                    this.allSponsors = response.features;
                    resolve(response);
                }
                else {
                    reject(new Error("No sponsors found."));
                }
            };
            indoorService.search(getConfig().map.indoorRendererOptions.venue || `sdm_${getConfig().map.eventYear}_${getConfig().map.env}`, "", cbSponsoredLogos, null, null, `Is_Sponsored:="yes"`);
        });
    }
    initializeLanguageSelector(): void {
        const languageSelector = document.querySelector(".sl-nav");

        if (languageSelector) {
            const languageOptions = languageSelector.querySelectorAll(".sl-flag");

            languageOptions.forEach((flagElement) => {
                const parentElement = flagElement.parentElement;
                const elementLang = flagElement.getAttribute("data-lang");
                if (elementLang) {
                    if (elementLang.toLowerCase() === getLocaleLang().toLowerCase()) {
                        const nextSibling = flagElement.nextElementSibling;
                        if (nextSibling) {
                            nextSibling.classList.add("active");
                        }
                        this.selectLanguage(getLocaleLang());
                    }
                }
                if (parentElement) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    parentElement.addEventListener("click", (event: MouseEvent) => {
                        const selectedLanguageCode = flagElement.getAttribute("data-lang");
                        window.lang = selectedLanguageCode || getLocaleLang();
                        languageOptions.forEach((option) => {
                            const span = option.parentElement?.querySelector("span");
                            span?.classList.remove("active");
                        });
                        const nextSibling = flagElement.nextElementSibling;

                        if (selectedLanguageCode) {
                            this.selectLanguage(selectedLanguageCode);
                        }
                        if (nextSibling) {
                            nextSibling.classList.add("active");
                        }
                    });
                }
            });
        }

    }
    selectLanguage(languageCode: string): void {
        const langElement = document.getElementById("selectdLang");
        if (langElement) {
            langElement.innerHTML = `<b>${languageCode.toString().toUpperCase()}</b>`;
        }
        this.emit(KioskComponentEvents.LANGUAGE_CHANGED, languageCode);
    }
    updateSessionCountdown() {
        const countdownElement = document.getElementById("countdownText");
        const $lnkReset = document.getElementById("lnkReset");
        const minutes = Math.floor(this.sessionDuration / 60);
        const seconds = this.sessionDuration % 60;
        if (countdownElement && $lnkReset) {
            countdownElement.innerHTML = `${getLocale().messages.sessionReset} <span style="color: red;font-family: monospace;font-weight:500">${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}</span> ${minutes < 1 ? getLocale().messages.seconds : getLocale().messages.minute}`;
            $lnkReset.style.visibility = 'visible';
            this.sessionDuration--;
            if (this.sessionDuration < 0) {
                clearInterval(this.countdownInterval);
                this.sessionDuration = this.TIMEOUT_LIMIT;
                countdownElement.textContent = "";
                this.resetMap();
            }
        }
    }
    startSessionCountdown() {
        this.sessionDuration = this.TIMEOUT_LIMIT;
        this.clearCountdownInterval();
        this.countdownInterval = setInterval(this.updateSessionCountdown, 1000);
    }
    clearCountdownInterval() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = 0;
        }
    }
    resetMap(): void {
        const countdownElement = document.getElementById("countdownText");
        const $lnkReset = document.getElementById("lnkReset");
        if (countdownElement && $lnkReset) {
            countdownElement.textContent = "";
            $lnkReset.style.visibility = 'hidden';
        }
        this.sendGAEvent();
        this.clearCountdownInterval();
        this.isMapReloaded = !this.isMapReloaded;
        this.emit(KioskComponentEvents.MAP_RELOAD, this.isMapReloaded);
        // location.reload();
    }
    sendGAEvent(): void {
        const currentTimeMillis: number = new Date().getTime();
        const currentUnixTimestamp: number = Math.floor(currentTimeMillis / 1000);
        const queryParam = this.state.query?.split('=');
        const kiosk = queryParam && queryParam?.length > 1 ? queryParam[1] : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "session_rest",
            timestamps: currentUnixTimestamp,
            content_id: kiosk,
            items: undefined,
            search_term: undefined,
            item_name: undefined,
            nav_from: undefined,
            nav_to: undefined,
            content_type: undefined
        });
    }
    removeExistingMarquees() {
        const marquees = document.querySelectorAll(".marquee-content");
        if (marquees.length > 0) {
            marquees.forEach((el) => {el.remove()});
        }
    }
    restartMarqueeAnimation(selector: string): void {
        requestAnimationFrame(() => {
            const marquees = document.querySelectorAll<HTMLElement>(selector);
            marquees.forEach((el) => {
                el.style.animation = "none"; // Stop the animation
                void el.offsetWidth; // Force reflow
                el.style.animation = ""; // Restart animation
            });
        });
    }
}